<div class="container flex">
  <div
    class="input-wrapper"
    [class.shrinked]="!showInput"
    [class.w-100]="screenService.isMobile$ | async"
  >
    <input
      #searchInput
      (ngModelChange)="search($event)"
      (keydown.escape)="onEscapeKey()"
      (blur)="onInputBlur()"
      nzSize="large"
      type="text"
      nz-input
      [placeholder]="showInput ? 'Buscar...' : ''"
      [ngModel]="searchValue"
    />
    <app-st-icon
      (click)="isJustClear = true; onInputBlur()"
      class="clean-preffix"
      [bold]="true"
      *ngIf="searchValue"
      name="close"
      [color]="'#8F8F8F'"
    ></app-st-icon>
  </div>

  <button
    (click)="toggleShowInput()"
    class="text-btn-16 flex-center"
    nz-button
    style="border: none"
    [nzType]="'text'"
    nzShape="circle"
    nzSize="large"
  >
    <app-st-icon
      class="flex-center"
      [name]="'search'"
      [bold]="true"
      [color]="'#8F8F8F'"
    ></app-st-icon>
  </button>

  <button
    (click)="toggleShowInput()"
    class="text-btn-16 flex-center"
    nz-button
    style="border: none"
    [nzType]="'text'"
    nzShape="circle"
    nzSize="large"
  >
    <app-st-icon
      class="flex-center"
      [name]="'search'"
      [bold]="true"
      [color]="'#8F8F8F'"
    ></app-st-icon>
  </button>
</div>
